import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/index'
import Redirect from './views/redirect'
import ShowPdf from './components/show-pdf'
import ShowMP4 from './components/show-mp4'
import Core from 'core/core'
Vue.use(Router)

/** 阻止组员通过直接输入地址进入权限管理的新增、编辑页面。 */
function checkAuthorityOperation(to, from, next) {
    const user = Core.Data.getUser();
    if (user && user.role === 102) {
        next('/authority');
        return;
    }
    next();
}

export default new Router({
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: Index,
            redirect: {
                path: "/login"
            }
        },
        {
            path: '/redirect',
            component: Redirect,
        },
        {
            path: '/login',
            hiddenUser: true,
            phoneShow: false,
            component: () => import('./views/login.vue')
        },
        {
            path: '/register',
            hiddenUser: true,
            phoneShow: false,
            component: () => import('./views/register.vue')
        },
        {
            path: '/retrieve',
            hiddenUser: true,
            phoneShow: false,
            component: () => import('./views/retrieve.vue')
        },
        {
            path: '/update-info',
            hiddenUser: true,
            name: '完善资料',
            phoneShow: false,
            component: () => import('./views/update-info.vue')
        },
        {
            path: '/home',
            component: Index,
            pathname: '数据看板',
            phoneShow: true,
            public: true,
            children: [
                {
                    path: '',
                    name: '首页',
                    component: () => import('./views/home/home.vue'),
                },
	            {
		            path: 'logbook',
		            name: '日志',
		            component: () => import('./views/home/logbook.vue'),
	            },

            ]
        },
        {
            path: '/device',
            component: Index,
            pathname: '设备管理',
            phoneShow: true,
            public: true,
            children: [
                {
                    path: '',
                    name: '设备列表',
                    component: () => import('./views/device/device-list.vue'),
                },
                {
                    path: 'gateway',
                    name: '网关列表',
                    component: () => import('./views/gateway/gateway-list.vue'),
                },
                {
                    path: 'gateway/add',
                    name: '网关列表',
                    component: () => import('./views/gateway/gateway-add.vue'),
                },
                {
                    path: 'add',
                    name: '新增设备',
                    component: () => import('./views/device/device-add.vue'),
                },

            ]
        },
        {
            path: '/dealer',
            component: Index,
            pathname: '服务商管理',
            phoneShow: true,
            public: true,
            children: [
                {
                    path: '',
                    name: '服务商列表',
                    component: () => import('./views/dealer/dealer-list.vue'),
                },
                {
                    path: 'add',
                    name: '新增服务商',
                    component: () => import('./views/dealer/add-dealer.vue'),
                },

            ]
        },
        {
            path: '/user',
            component: Index,
            pathname: '客户管理',
            public: true,
            phoneShow: false,
            children: [
                {
                    path: '',
                    name: '客户管理',
                    component: () => import('./views/user/user-list.vue'),
                }

            ]
        },
        {
            path: '/log',
            component: Index,
            pathname: '操作日志',
            phoneShow: true,
            public: true,
            children: [
                {
                    path: '',
                    name: '操作日志',
                    component: () => import('./views/log/log-list.vue'),
                },
	            {
		            path: 'warning',
		            name: '告警日志',
		            component: () => import('./views/log/log-warning-list.vue')
	            }
            ]
        },
        {
            path: '/authority',
            component: Index,
            pathname: '权限管理',
            public: true,
            phoneShow: false,
            children: [
                {
                    path: '',
                    name: '权限管理',
                    component: () => import('./views/authority/authority-list.vue')
                },{
                    path: '/authority/add',
                    name: '新增分组',
                    beforeEnter: checkAuthorityOperation,
                    component: () => import('./views/authority/authority-add.vue')
                },{
                    path: '/authority/addMember',
                    name: '新增成员',
                    beforeEnter: checkAuthorityOperation,
                    component: () => import('./views/authority/authority-add-member.vue')
                }
            ]
        },
        {
            path: '/storage',
            component: Index,
            pathname: '入库',
            public: true,
            phoneShow: false,
            children: [
                {
                    path: '',
                    name: '入库',
                    component: () => import('./views/store/store-list.vue'),
                },
            ]
        },
        {
            path: '/distribution',
            component: Index,
            pathname: '分配',
            public: true,
            phoneShow: false,
            children: [
                {
                    path: '',
                    name: '分配',
                    component: () => import('./views/store/store-list.vue'),
                },

            ]
        },
        {
            path: '/setting',
            component: Index,
            pathname: '设置',
            phoneShow: true,
            public: true,
            children: [
                {
                    path: '',
                    name: '设置',
                    component: () => import('./views/setting/setting.vue'),
                },

            ]
        },
	    {
		    path: '/help',
		    component: Index,
		    pathname: '帮助',
		    public: true,
            phoneShow: false,
		    children: [
			    {
				    path: '',
				    name: '帮助',
				    component: () => import('./views/help/help-list.vue'),
			    },
		    ]
	    },
	    {
		    path: '/show-pdf',
		    component: ShowPdf,
            phoneShow: false,
		    pathname: 'pdf',
	    },
        {
            path: '/show-mp4',
            component: ShowMP4,
            phoneShow: false,
            pathname: 'pdf',
        },


    ]
})
